import { Component, HostListener, OnInit, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Breadcrumb } from '../models/breadcrum.model';
import { BreadcrumbService } from '../services/breadcrumb.service';

import { LinkComponent } from '../../link/link.component';
import { SlColumnComponent, SlGridComponent, SlTypographyComponent } from '@fundacion/components';

@Component({
  standalone: true,
  imports: [CommonModule, SlTypographyComponent, LinkComponent, SlGridComponent, SlColumnComponent],
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs$: Observable<Breadcrumb[]>;
  isNews: Signal<boolean>;
  responsivePadding!: string;
  responsiveColumns!: number;
  responsiveEndColumn!: number;

  constructor(private readonly breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
    this.isNews = this.breadcrumbService.news;
  }

  ngOnInit(): void {
    this.checkScreenWidth(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.checkScreenWidth(width);
  }

  private checkScreenWidth(width: number): void {
    if (width <= 769) {
      this.responsivePadding = '16px';
      this.responsiveColumns = 4;
      this.responsiveEndColumn = 4;
    } else {
      this.responsivePadding = '104px';
      this.responsiveColumns = 12;
      this.responsiveEndColumn = 12;
    }
  }
}
